import { createRoot, createSignal } from 'solid-js';

export type CookieConsent = 'all' | 'necessary' | null;

const LS_KEY = 'concept13.cookies.consent';

const lsAvailable = (): boolean => {
  try {
    return typeof window !== 'undefined' && !!window.localStorage;
  } catch {
    return false;
  }
};

function load(): CookieConsent {
  if (!lsAvailable()) return null;
  try {
    const raw = window.localStorage.getItem(LS_KEY);
    if (raw === 'all' || raw === 'necessary') return raw;
    return null;
  } catch {
    return null;
  }
}

function save(value: CookieConsent) {
  if (!lsAvailable()) return;
  try {
    if (value === null) window.localStorage.removeItem(LS_KEY);
    else window.localStorage.setItem(LS_KEY, value);
  } catch {
    /* ignore */
  }
}

function createStore() {
  const [consent, setConsent] = createSignal<CookieConsent>(load());
  const [configureOpen, setConfigureOpen] = createSignal(false);

  const acceptAll = () => {
    setConsent('all');
    save('all');
    setConfigureOpen(false);
  };
  const acceptNecessary = () => {
    setConsent('necessary');
    save('necessary');
    setConfigureOpen(false);
  };
  const openConfigure = () => setConfigureOpen(true);
  const reset = () => {
    setConsent(null);
    save(null);
    setConfigureOpen(false);
  };

  return {
    consent,
    isDecided: () => consent() !== null,
    configureOpen,
    acceptAll,
    acceptNecessary,
    openConfigure,
    reset,
  };
}

export const cookieStore = createRoot(() => createStore());
